export default __webpack_public_path__ + "static/ak-cached/24h/media/apple-tv-4k-32gb.da4fbc82.jpeg";